import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import AdminLayout from '../AdminLayout';
import { Row, Col, Table, Tag, message } from 'antd';
import * as actions from '../redux/actions';
import { API } from '../../../helper/api';
import moment from 'moment';
import { STATUS, is } from './Constants';


const columns = [{
  title: 'Etudiant',
  dataIndex: 'fullName'
}, {
  title: 'Téléphone',
  dataIndex: 'phoneNumber',
  //render: (date) => moment().diff(date, 'years')
}, {
  title: 'Email',
  dataIndex: 'email',
  //render: (point) => !point ? 0 : point
},
{
  title: 'Classe',
  dataIndex: 'promotion',
  key: 'classe',
  render: (promotion) => <Tag>{promotion.name}</Tag>
}, {
  title: 'Classe Description',
  dataIndex: 'promotion',
  key: 'description',
  render: (promotion) => <Tag>{promotion.description}</Tag>
}];


export class UsersPresence extends Component {
  static propTypes = {
    admin: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    event: {},
    user: [],
    loadingEvent: true,
    loading: true,
    selected_to_validate: [],
    selectedRowKeys_to_validate: null,
    selected_validated: [],
    selectedRowKeys_validated: null
  }

  confirm(isValid) {
    const suffix = [isValid ? '_to_validate' : '_validated'];
    this.state['selected' + suffix].map(id =>
      API['post']('Booking/validate', { userId: id, eventId: this.props.match.params.id, presence: isValid })
        .then((res) => this.getUsers())
        .then((res) => this.setState({ ['selected' + suffix]: [], ['selectedRowKeys' + suffix]: null }))
        .then(() => message.success(isValid ? "Presence validé" : "Absence corrigée"))
        .catch(() => message.error("Action impossible"))
    )
  }
  getUsers() {
    this.setState({ loading: true })
    API.get('Booking/users_status/' + this.props.match.params.id)
      .then((res) => this.setState({ user: res.data, loading: false, selected: [] }))
  }

  componentDidMount() {
    let isAllowed = false;

    //get event info for access
    API.get('event/' + this.props.match.params.id, { moderators: 'True' })
      .then(res => {
        const event = res.data.event;
        isAllowed = this.props.isAdmin || event.moderators.map(m => m.user.email).includes(this.props.email);

        if (!isAllowed) {
          this.props.history.replace('/404');
          return Promise.reject("wrong page");
        } /* else if( is(event, true) === STATUS.COMING ){
          this.props.history.replace('/admin/events/registration/'+this.props.match.params.id)
          return Promise.reject("wrong page");
        } */ else {
          return event;
        }
      })
      .then(event => this.setState({ event, loadingEvent: false }))
      //get info to the user of this event
      .then(() => this.getUsers());

  }

  render() {
    const { event } = this.state;
    let buttons = []

    if (this.props.admin)
      buttons.push({
        icon: "stop",
        name: "ABSENT",
        type: "danger",
        disabled: this.state.selected_validated.length === 0,
        onClick: () => this.confirm(false)
      });

    buttons.push({
      icon: "cloud-upload",
      name: "PRESENT",
      disabled: this.state.selected_to_validate.length === 0,
      onClick: () => this.confirm(true)
    })

    return (
      <div className="UserPresence-content">
        <AdminLayout
          title={event.title ? event.title + " - PRESENCE" : "PRESENCE"}
          back={this.props.isAdmin ? "/admin/events" : () => this.props.history.goBack()}
          loading={this.state.loadingEvent}
          buttons={buttons}
        >
          <Row>
            <Row style={{ width: '100%' }} type="flex" justify="start">
              <Col span={24} style={{ margin: '20px 0 20px 10px' }}>
                <h1>PRESENTS <Tag color="#87d068" style={{ float: 'left' }}>{this.state.user.filter(u => u.present).length}</Tag></h1>
              </Col>
            </Row>
            <Table
              rowSelection={{
                onChange: (selectedRowKeys, selectedRows) => {
                  this.setState({ selectedRowKeys_validated: selectedRowKeys, selected_validated: selectedRows.map(u => u.id) })
                },
                selectedRowKeys: this.state.selectedRowKeys_validated
              }
              }
              loading={this.state.loading}
              columns={columns}
              pagination={false}
              dataSource={this.state.user.filter(u => u.present).map(u => u.user)} />
          </Row>
          <Row>
            <Row style={{ width: '100%' }} type="flex" justify="start">
              <Col span={24} style={{ margin: '20px 0 20px 10px' }}>
                <h1>INSCRITS <Tag color="blue" style={{ float: 'left' }}>{this.state.user.filter(u => !u.present).length}</Tag></h1>
              </Col>
            </Row>
            <Table
              rowSelection={{
                onChange: (selectedRowKeys, selectedRows) => {
                  this.setState({ selectedRowKeys_to_validate: selectedRowKeys, selected_to_validate: selectedRows.map(u => u.id) })
                },
                selectedRowKeys: this.state.selectedRowKeys_to_validate
              }
              }
              columns={columns}
              loading={this.state.loading}
              pagination={false}
              dataSource={this.state.user.filter(u => !u.present).map(u => u.user)} />
          </Row>
        </AdminLayout>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    admin: state.admin,
    isAdmin: state.authentification.isAdmin,
    email: state.authentification.user.email
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UsersPresence);


// WEBPACK FOOTER //
// ./src/features/admin/events/UsersPresence.js